import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Input, LabelText, SubmitButton, FlexContainer, LeftBackButtonText, H1Text, Hr, Text, Img, InputWrapper } from "../../design";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { axiosLoginInstance, BASE_URLS } from "../../api";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import ArrowIcon from "../../assets/imgs/forwardarrow.svg";
import {EMAIL} from "../../appconstants";

type Props = {
    history: {
        push: Function,
    },
}

const ForgotPassword = (props: Props) => {
    const [errorMessage, setErrorMessage] = useState();
    const [readOnly, setReadOnly] = useState([]);
    const [showerrorMessage, setShowErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);

    const { handleSubmit, errors, control } = useForm();
    const onSubmit = async (payload) => {
        localStorage.setItem('email', payload.email.trim());
        try {
            await axiosLoginInstance.post(BASE_URLS.FORGOT_PASSWORD, {
                email: payload.email.trim(),
            });
            setSuccess(true);
        } catch (e) {
            setShowErrorMessage(true);
            setErrorMessage(e && e.data ? e.data.message : 'Unable to process request. Please try again later');
        }
    }

    useEffect(() => {
        if (success) {
            props.history.replace('/resetpassword');
        }
    }, [success]);

    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        <LeftBackButtonText
                            onClick={() => { props.history.push(`/login`); }}
                        >
                            Back
                      </LeftBackButtonText>
                        <H1Text>
                            Configure Payments
                      </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                <FlexContainer
                    className="pt-3 pt-lg-5"
                    box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    display="flow-root"
                >
                    <H1Text
                        className="px-1 px-md-4 mt-4"
                    >
                        ACCOUNT SETUP
                    </H1Text>

                    <Text className="px-1 px-md-4" paddingBottom="8px">
                        Forgot Password
                    </Text>
                    <Hr />
                    <div className="px-1 px-md-4 mt-2">
                        <FlexContainer
                            flexDirection="column"
                        >
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <LabelText className="mt-4 mb-2">
                                    Email
                                </LabelText>
                                <Controller
                                    marginBottom="0px"
                                    defaultValue={""}
                                    control={control}
                                    name="email"
                                    placeholder="Enter your email address"
                                    rules={{
                                        required: 'Email is required',
                                        pattern: {
                                            value: EMAIL.DEFAULT_REGEX,
                                            message: EMAIL.DEFAULT_ERROR_MESSAGE,
                                        },
                                    }}
                                    as={<Input readOnly={readOnly && readOnly.includes("email")} />}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="email"
                                    render={({ message }) => (
                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                />
                                <div>
                                    <SubmitButton
                                        type="submit"
                                        style={{ width: '292px' }}
                                    >NEXT <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                                </div>
                                {showerrorMessage && <PaymentError header={errorMessage} message={null} />}
                            </form>
                        </FlexContainer>
                    </div>
                </FlexContainer>
            </>
        } />
    )
};

export default ForgotPassword;
